/* ============================================
   ADEQO PRODUCT PAGE - JAVASCRIPT
   Vanilla JS, no frameworks
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Gedeelde B2B-prijsengine (cross-sell preview) ----------
     Productpagina-cross-sell toont een PREVIEW van de B2B-prijs: strip BTW
     (excl-BTW) + pas BSS-staffelkorting toe. De winkelwagen blijft de bron
     van waarheid (final_line_price). BTW-tarief instelbaar via theme settings. */
  function adeqoIsB2B() {
    // Autoritatief: de Liquid-vlag uit customer.tags. Is die bekend (altijd
    // gerenderd als boolean), dan is dat de waarheid — géén BSS-DOM-heuristiek
    // die een B2C-klant alsnog als B2B aanmerkt (BSS rendert die elementen ook
    // voor B2C, wat de cross-sell ten onrechte BTW liet strippen).
    if (window.adeqoCustomer && typeof window.adeqoCustomer.isB2B === 'boolean') {
      return window.adeqoCustomer.isB2B;
    }
    // Fallback (vlag onbekend): BSS heeft een B2B-prijs gerenderd → B2B.
    if (document.querySelector('[bss-b2b-product-active="true"]')) return true;
    var p = document.querySelector('.bss-b2b-price-no-vat');
    return !!(p && /\d/.test(p.textContent || ''));
  }
  function adeqoStripVat(cents) {
    var rate = (window.adeqoCustomer && window.adeqoCustomer.b2bTaxRate) || 21;
    return Math.round(cents / (1 + rate / 100));
  }
  function adeqoCustomerTags() {
    var tags = (window.adeqoCustomer && window.adeqoCustomer.tags) || [];
    if (typeof tags === 'string') tags = tags.split(',');
    return tags.map(function (t) { return String(t).trim().toLowerCase(); }).filter(Boolean);
  }
  function adeqoBssRules() {
    var qb = window.BSS_B2B && window.BSS_B2B.qb;
    return (qb && Array.isArray(qb.qbRules)) ? qb.qbRules : [];
  }
  function adeqoRuleApplies(rule, productId, customerTags) {
    if (rule.customer_tags) {
      var required = String(rule.customer_tags).split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
      if (required.length > 0) {
        var hasTag = customerTags.some(function (t) { return required.indexOf(t) !== -1; });
        if (!hasTag) return false;
      }
    }
    var applyTo = parseInt(rule.apply_to, 10);
    if (applyTo === 4 && rule.product_ids) {
      var ids = String(rule.product_ids).split(',').map(function (s) { return s.trim(); });
      if (ids.indexOf(String(productId)) === -1) return false;
    }
    return true;
  }
  function adeqoActiveRule(productId, customerTags) {
    var rules = adeqoBssRules().filter(function (r) { return adeqoRuleApplies(r, productId, customerTags); });
    if (!rules.length) return null;
    rules.sort(function (a, b) { return (a.priority || 0) - (b.priority || 0); });
    return rules[0];
  }
  function adeqoTierForQty(rule, qty) {
    if (!rule || !rule.qty_table) return null;
    for (var i = 0; i < rule.qty_table.length; i++) {
      var t = rule.qty_table[i];
      var to = (t.qty_to == null) ? Infinity : t.qty_to;
      if (qty >= t.qty_from && qty <= to) return t;
    }
    return null;
  }
  // B2B-preview unit-prijs (cents): strip BTW, dan staffelkorting. Niet-B2B → incl-prijs ongewijzigd.
  function adeqoB2BUnitPrice(productId, inclCents, qty) {
    if (!adeqoIsB2B() || !inclCents) return inclCents;
    var exVat = adeqoStripVat(inclCents);
    var tags = adeqoCustomerTags();
    var rule = adeqoActiveRule(productId, tags);
    if (!rule) return exVat;
    var tier = adeqoTierForQty(rule, qty);
    if (!tier) return exVat;
    var pct = parseFloat(tier.discount_value) || 0;
    if (pct <= 0) return exVat;
    var dtype = tier.discount_type;
    var isPercent = (dtype === 2 || dtype === 'percent' || dtype === '%' || !dtype);
    if (isPercent) return Math.round(exVat * (100 - pct) / 100);
    return Math.max(0, exVat - Math.round(pct * 100));
  }

  /* ---------- Product Gallery ---------- */
  (function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var heroImg = gallery.querySelector('[data-gallery-hero-img]');
    var heroWrap = gallery.querySelector('[data-gallery-hero]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var gridItems = gallery.querySelectorAll('[data-gallery-grid-item]');
    var theater = gallery.querySelector('[data-gallery-theater]');
    // Move theater to body to escape sticky stacking context
    if (theater) document.body.appendChild(theater);
    var theaterImages = theater ? theater.querySelectorAll('[data-theater-image]') : [];
    var theaterCounter = theater ? theater.querySelector('[data-theater-counter]') : null;
    var totalImages = theaterImages.length;
    var currentTheaterIndex = 0;

    // === Mobile thumbnail switching ===
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.dataset.index);
        // Update hero image src from theater images (high-res source)
        var theaterImg = theater ? theater.querySelector('[data-theater-image][data-index="' + idx + '"]') : null;
        if (theaterImg && heroImg) {
          heroImg.src = theaterImg.src;
          heroImg.srcset = theaterImg.srcset || '';
          heroImg.alt = theaterImg.alt;
          heroImg.dataset.index = idx;
        }
        // Update active thumb
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // === Theater view ===
    function openTheater(index) {
      if (!theater || totalImages === 0) return;
      currentTheaterIndex = index;
      showTheaterImage(currentTheaterIndex);
      theater.classList.add('is-open');
      theater.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeTheater() {
      if (!theater) return;
      theater.classList.remove('is-open');
      theater.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function showTheaterImage(index) {
      theaterImages.forEach(function (img) { img.classList.remove('is-active'); });
      var target = theater.querySelector('[data-theater-image][data-index="' + index + '"]');
      if (target) target.classList.add('is-active');
      if (theaterCounter) theaterCounter.textContent = (index + 1) + ' / ' + totalImages;
    }

    function theaterNext() {
      currentTheaterIndex = (currentTheaterIndex + 1) % totalImages;
      showTheaterImage(currentTheaterIndex);
    }

    function theaterPrev() {
      currentTheaterIndex = (currentTheaterIndex - 1 + totalImages) % totalImages;
      showTheaterImage(currentTheaterIndex);
    }

    // Hero click → open theater
    if (heroWrap) {
      heroWrap.addEventListener('click', function () {
        var idx = parseInt(heroImg.dataset.index) || 0;
        openTheater(idx);
      });
    }

    // Grid items click → open theater
    gridItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var idx = parseInt(item.dataset.index) || 0;
        openTheater(idx);
      });
    });

    // Close buttons
    if (theater) {
      theater.querySelectorAll('[data-theater-close]').forEach(function (el) {
        el.addEventListener('click', closeTheater);
      });
    }

    // Nav buttons
    var prevBtn = theater ? theater.querySelector('[data-theater-prev]') : null;
    var nextBtn = theater ? theater.querySelector('[data-theater-next]') : null;
    if (prevBtn) prevBtn.addEventListener('click', theaterPrev);
    if (nextBtn) nextBtn.addEventListener('click', theaterNext);

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (!theater || !theater.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeTheater();
      if (e.key === 'ArrowLeft') theaterPrev();
      if (e.key === 'ArrowRight') theaterNext();
    });

    // Touch swipe in theater
    var touchStartX = 0;
    var touchEndX = 0;
    var stage = theater ? theater.querySelector('[data-theater-stage]') : null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) theaterNext();
          else theaterPrev();
        }
      }, { passive: true });
    }
  })();

  /* ---------- Mobile Breadcrumbs Reposition ---------- */
  (function initMobileBreadcrumbs() {
    var breadcrumbsNav = document.querySelector('.adeqo-product-hero__breadcrumbs');
    if (!breadcrumbsNav) return;

    var breadcrumbsBlock = breadcrumbsNav.closest('.adeqo-product-block');
    if (!breadcrumbsBlock) return;

    var layout = document.querySelector('.adeqo-product-hero__layout');
    var galleryCol = document.querySelector('.adeqo-product-hero__gallery');
    var productInfo = document.querySelector('.adeqo-product-info');
    if (!layout || !galleryCol || !productInfo) return;

    var originalParent = breadcrumbsBlock.parentNode;
    var originalNext = breadcrumbsBlock.nextElementSibling;
    var mq = window.matchMedia('(max-width: 767px)');

    function handleBreakpoint(e) {
      if (e.matches) {
        // Mobile: place breadcrumbs before gallery column
        layout.insertBefore(breadcrumbsBlock, galleryCol);
      } else {
        // Desktop: return breadcrumbs to product info (original position)
        if (originalNext) {
          originalParent.insertBefore(breadcrumbsBlock, originalNext);
        } else {
          originalParent.appendChild(breadcrumbsBlock);
        }
      }
    }

    mq.addEventListener('change', handleBreakpoint);
    handleBreakpoint(mq);
  })();

  /* ---------- Divider de-dup ----------
     Scheidingslijnen zijn losse blocks. Liquid collapt dividers al op basis van
     het vorige block-type, maar een block dat WEL rendert maar visueel leeg is
     (een BSS-staffel zonder quantity breaks: "Zonder BSS data blijft het blok
     leeg") laat twee lijnen tegen elkaar staan -> "dubbele lijn". Dat kan Liquid
     niet weten. Hier meten we de echte render-hoogte en verbergen overbodige
     dividers (leidend, dubbel, of zonder zichtbare inhoud erna). Re-run omdat de
     BSS-app de staffel pas na load injecteert. */
  (function initDividerCollapse() {
    var productInfo = document.querySelector('.adeqo-product-info');
    if (!productInfo) return;

    function isDivider(block) {
      return !!block.querySelector('.adeqo-product-info__divider');
    }

    function isVisibleContent(block) {
      if (block.offsetParent === null) return false;
      return block.getBoundingClientRect().height > 0.5;
    }

    function collapse() {
      var blocks = productInfo.querySelectorAll(':scope > .adeqo-product-block');
      var sawContent = false;
      var pendingTrailingDivider = null;
      blocks.forEach(function (block) {
        if (isDivider(block)) {
          if (sawContent) {
            block.style.display = '';
            sawContent = false;
            pendingTrailingDivider = block;
          } else {
            // Leidende of opeenvolgende divider zonder inhoud ertussen.
            block.style.display = 'none';
          }
        } else if (isVisibleContent(block)) {
          sawContent = true;
          pendingTrailingDivider = null;
        }
      });
      // Divider zonder zichtbare inhoud erna is overbodig.
      if (pendingTrailingDivider) pendingTrailingDivider.style.display = 'none';
    }

    collapse();
    setTimeout(collapse, 600);
    setTimeout(collapse, 1600);
  })();

  /* ---------- Quantity Selector ---------- */
  (function initQuantity() {
    // Werkt op zowel oude .adeqo-product-info__quantity-controls als
    // nieuwe .adeqo-purchase-row__qty containers
    const containers = document.querySelectorAll(
      '.adeqo-product-info__quantity-controls, .adeqo-purchase-row__qty'
    );
    if (!containers.length) return;

    function findInput(container) {
      return container.querySelector(
        '.adeqo-product-info__quantity-input, .adeqo-purchase-row__qty-input, [data-qty-select]'
      );
    }

    containers.forEach(function (container) {
      const input = findInput(container);
      const minusBtn = container.querySelector('[data-action="decrease"]');
      const plusBtn = container.querySelector('[data-action="increase"]');
      if (!input) return;

      const quantityBlock = container.closest('.adeqo-product-info__quantity');
      const m2PerPaneel = parseFloat((quantityBlock && quantityBlock.dataset.m2PerPaneel) || input.dataset.m2PerPaneel) || 0;
      const m2Display = quantityBlock ? quantityBlock.querySelector('[data-m2-value]') : null;

      function updateM2(qty) {
        if (m2Display && m2PerPaneel > 0) {
          m2Display.textContent = (qty * m2PerPaneel).toFixed(2).replace(/\.?0+$/, '');
        }
      }

      function updateQuantity(newVal) {
        var min = parseInt(input.min) || 1;
        var max = parseInt(input.max) || 9999;
        newVal = Math.max(min, Math.min(max, newVal));
        input.value = newVal;
        updateM2(newVal);
        updatePurchaseRowInfo(newVal);

        // Sync alle andere qty inputs op de pagina
        document.querySelectorAll(
          '.adeqo-product-info__quantity-input, .adeqo-purchase-row__qty-input'
        ).forEach(function (other) {
          if (other !== input) other.value = newVal;
        });

        document.dispatchEvent(new CustomEvent('adeqo:quantity-changed', {
          detail: { quantity: newVal }
        }));
      }

      function updatePurchaseRowInfo(qty) {
        var info = document.querySelector('[data-purchase-info]');
        if (!info) return;
        var m2PerPaneel = parseFloat(info.dataset.m2PerPaneel) || 0;
        var unitPrice = parseInt(info.dataset.unitPrice, 10) || 0;
        var m2Total = info.querySelector('[data-m2-total]');
        var subtotalEl = info.querySelector('[data-subtotal]');
        if (m2Total && m2PerPaneel > 0) {
          var totalM2 = qty * m2PerPaneel;
          m2Total.textContent = totalM2.toFixed(2).replace(/\.?0+$/, '').replace('.', ',');
        }
        if (subtotalEl && unitPrice > 0) {
          var totalCents = unitPrice * qty;
          subtotalEl.textContent = '€' + (totalCents / 100).toFixed(2).replace('.', ',');
        }
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          updateQuantity(parseInt(input.value) - 1);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          updateQuantity(parseInt(input.value) + 1);
        });
      }

      input.addEventListener('change', function () {
        updateQuantity(parseInt(input.value) || 1);
      });
    });
  })();

  /* ---------- Upsell Toggle ---------- */
  (function initUpsells() {
    const items = document.querySelectorAll('.adeqo-upsell-item');
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        item.classList.toggle('is-checked');
        recalculateTotal();
      });
    });
  })();

  /* ---------- Recalculate Order Total ---------- */
  function recalculateTotal() {
    var subtotalEl = document.querySelector('[data-order-subtotal]');
    var totalEl = document.querySelector('[data-order-total]');
    if (!subtotalEl || !totalEl) return;

    var subtotal = parseFloat(subtotalEl.dataset.orderSubtotal) || 0;
    var upsellTotal = 0;

    document.querySelectorAll('.adeqo-upsell-item.is-checked').forEach(function (item) {
      upsellTotal += parseFloat(item.dataset.price) || 0;
    });

    var total = subtotal + upsellTotal;
    totalEl.textContent = '\u20AC' + total.toFixed(2).replace('.', ',');
  }

  /* ---------- Add to Cart (adaptief: standaard product OF sample mode) ---------- */
  (function initAddToCart() {
    const buttons = document.querySelectorAll('[data-add-to-cart]');

    function readQty() {
      // Eerst de Godu-stijl select dropdown
      var qtySelect = document.querySelector('[data-qty-select]');
      if (qtySelect) return parseInt(qtySelect.value, 10) || 1;
      // Fallback voor oude markup met number input
      var qtyInput = document.querySelector('.adeqo-product-info__quantity-input');
      if (qtyInput) return parseInt(qtyInput.value, 10) || 1;
      return 1;
    }

    function buildSampleItems() {
      var swatches = document.querySelectorAll('[data-sample-swatch].is-selected');
      var items = [];
      swatches.forEach(function (s) {
        if (s.classList.contains('is-unavailable')) return;
        items.push({ id: parseInt(s.dataset.variantId, 10), quantity: 1 });
      });
      return items;
    }

    function buildStandardItems(button) {
      var variantInput = document.getElementById('adeqo-selected-variant-id');
      var variantId = variantInput ? variantInput.value : button.dataset.variantId;
      if (!variantId) return [];

      var items = [{
        id: parseInt(variantId, 10),
        quantity: readQty()
      }];

      // Add checked upsells (order_summary block)
      document.querySelectorAll('.adeqo-upsell-item.is-checked').forEach(function (item) {
        var upsellVariantId = item.dataset.variantId;
        var upsellQty = parseInt(item.dataset.quantity) || 1;
        if (upsellVariantId) {
          items.push({ id: parseInt(upsellVariantId, 10), quantity: upsellQty });
        }
      });

      // Add active cross-sell items
      document.querySelectorAll('[data-crosssell-item].is-active').forEach(function (item) {
        var csVariantId = item.dataset.variantId;
        var csQtyInput = item.querySelector('[data-crosssell-qty]');
        var csQty = csQtyInput ? parseInt(csQtyInput.value) : 1;
        if (csVariantId && csQty > 0) {
          items.push({ id: parseInt(csVariantId, 10), quantity: csQty });
        }
      });

      return items;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        if (button.disabled) return;

        var isSampleMode = button.hasAttribute('data-sample-mode');
        var items = isSampleMode ? buildSampleItems() : buildStandardItems(button);
        if (items.length === 0) return;

        var atcText = button.querySelector('[data-atc-text]');
        var loadingText = button.dataset.loadingText || 'Toevoegen...';
        var successText = button.dataset.successText || 'Toegevoegd!';
        var defaultText = button.dataset.defaultText || 'Toevoegen aan winkelwagen';
        var sampleEmptyText = button.dataset.sampleEmptyText || 'Selecteer minstens één sample';
        var sampleActiveText = button.dataset.sampleActiveText || 'Voeg samples toe aan winkelwagen';

        // Loading state
        button.disabled = true;
        if (atcText) {
          atcText.textContent = loadingText;
        } else {
          // Fallback voor oude markup zonder data-atc-text
          var originalHTML = button.innerHTML;
          button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10" stroke-dasharray="32" stroke-dashoffset="12" class="adeqo-spinner"></circle></svg><span>' + loadingText + '</span>';
          button.dataset._originalHtml = originalHTML;
        }

        var source = isSampleMode ? 'sample-configurator' : 'product-page';

        window.AdeqoCart.add(items, { source: source })
          .then(function () {
            if (atcText) {
              atcText.textContent = successText;
            } else {
              button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg><span>' + successText + '</span>';
            }
            setTimeout(function () {
              if (isSampleMode) {
                // sample-configurator-adeqo.js handelt selection clearing af
                // ATC blijft disabled tot er weer iets geselecteerd is
                if (atcText) atcText.textContent = sampleEmptyText;
                button.disabled = true;
              } else {
                button.disabled = false;
                if (atcText) {
                  atcText.textContent = defaultText;
                } else if (button.dataset._originalHtml) {
                  button.innerHTML = button.dataset._originalHtml;
                  delete button.dataset._originalHtml;
                }
              }
            }, 2000);
          })
          .catch(function (error) {
            console.error('Add to cart error:', error);
            button.disabled = false;
            if (atcText) {
              atcText.textContent = isSampleMode
                ? (buildSampleItems().length > 0 ? sampleActiveText : sampleEmptyText)
                : defaultText;
            } else if (button.dataset._originalHtml) {
              button.innerHTML = button.dataset._originalHtml;
              delete button.dataset._originalHtml;
            }
          });
      });
    });

    // Sample mode: luister naar selectie wijzigingen → update prijs + ATC state
    document.addEventListener('adeqo:samples:changed', function (e) {
      var detail = e.detail;
      var atcBtn = document.querySelector('[data-add-to-cart][data-sample-mode]');
      var priceEl = document.querySelector('[data-product-price]');

      if (priceEl) {
        priceEl.textContent = detail.totalFormatted;
      }

      if (atcBtn) {
        var atcText = atcBtn.querySelector('[data-atc-text]');
        var sampleEmptyText = atcBtn.dataset.sampleEmptyText || 'Selecteer minstens één sample';
        var sampleActiveText = atcBtn.dataset.sampleActiveText || 'Voeg samples toe aan winkelwagen';
        if (detail.count === 0) {
          atcBtn.disabled = true;
          if (atcText) atcText.textContent = sampleEmptyText;
        } else {
          atcBtn.disabled = false;
          if (atcText) atcText.textContent = sampleActiveText;
        }
      }
    });
  })();

  /* ---------- Compact Calculator (in hero) ---------- */
  (function initCompactCalc() {
    var calc = document.querySelector('.adeqo-compact-calc');
    if (!calc) return;

    var toggle = calc.querySelector('.adeqo-compact-calc__toggle');
    var heightInput = calc.querySelector('[data-calc-height]');
    var widthInput = calc.querySelector('[data-calc-width]');
    var result = calc.querySelector('.adeqo-compact-calc__result');
    var resultValue = calc.querySelector('.adeqo-compact-calc__result-value');
    var warning = calc.querySelector('[data-calc-warning]');
    var warningText = calc.querySelector('[data-calc-warning-text]');

    toggle.addEventListener('click', function () {
      calc.classList.toggle('is-open');
    });

    function calculate() {
      var h = parseFloat(heightInput.value);
      var w = parseFloat(widthInput.value);
      var panelH = parseFloat(calc.dataset.panelHeight) || 260;
      var panelW = parseFloat(calc.dataset.panelWidth) || 60;

      if (h > 0 && w > 0) {
        // Kolommen × rijen = installatie-realiteit (panelen kun je niet vrij knippen)
        var cols = Math.ceil(w / panelW);
        var rows = Math.ceil(h / panelH);
        var panels = cols * rows;
        resultValue.textContent = panels + ' panelen';
        result.classList.add('is-visible');

        // Waarschuwing: wand hoger dan 1 paneel → meerdere rijen nodig
        if (warning && warningText) {
          if (h > panelH) {
            warningText.textContent = window.theme.t('product_wall_warning', 'Je wand is hoger dan 1 paneel ({height} cm). Er zijn {rows} rijen nodig (snijwerk vereist).').replace('{height}', panelH).replace('{rows}', rows);
            warning.hidden = false;
          } else {
            warning.hidden = true;
          }
        }

        // Update quantity
        document.dispatchEvent(new CustomEvent('adeqo:calculator-result', {
          detail: { panels: panels }
        }));
      } else {
        result.classList.remove('is-visible');
        if (warning) warning.hidden = true;
      }
    }

    if (heightInput && widthInput) {
      heightInput.addEventListener('input', calculate);
      widthInput.addEventListener('input', calculate);
    }
    // Paneelmaten komen server-side uit het metaobject (custom.calculator); geen variant-sync nodig.
  })();

  /* ---------- Full Calculator Section ---------- */
  (function initFullCalculator() {
    var calc = document.querySelector('.adeqo-product-calculator__card');
    if (!calc) return;

    var heightInput = calc.querySelector('[data-calc-height]');
    var widthInput = calc.querySelector('[data-calc-width]');
    var result = calc.querySelector('.adeqo-product-calculator__result');
    var resultValue = calc.querySelector('.adeqo-product-calculator__result-value');
    var addBtn = calc.querySelector('.adeqo-product-calculator__add-btn');

    function calculate() {
      var h = parseFloat(heightInput.value);
      var w = parseFloat(widthInput.value);
      var panelH = parseFloat(calc.dataset.panelHeight) || 260;
      var panelW = parseFloat(calc.dataset.panelWidth) || 60;

      if (h > 0 && w > 0) {
        // Kolommen × rijen = installatie-realiteit (panelen kun je niet vrij knippen)
        var cols = Math.ceil(w / panelW);
        var rows = Math.ceil(h / panelH);
        var panels = cols * rows;
        resultValue.textContent = panels + ' panelen';
        result.classList.add('is-visible');
        if (addBtn) {
          addBtn.classList.add('is-visible');
          addBtn.dataset.calculatedQuantity = panels;
        }
      } else {
        result.classList.remove('is-visible');
        if (addBtn) addBtn.classList.remove('is-visible');
      }
    }

    if (heightInput && widthInput) {
      heightInput.addEventListener('input', calculate);
      widthInput.addEventListener('input', calculate);
    }

    // Calculator add to cart
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantInput = document.getElementById('adeqo-selected-variant-id');
        var variantId = variantInput ? variantInput.value : addBtn.dataset.variantId;
        var qty = parseInt(addBtn.dataset.calculatedQuantity) || 1;

        if (!variantId) return;

        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Toevoegen...';

        window.AdeqoCart.add(
          [{ id: parseInt(variantId), quantity: qty }],
          { source: 'product-page-calculator' }
        )
          .then(function () {
            addBtn.textContent = 'Toegevoegd!';
            setTimeout(function () {
              addBtn.disabled = false;
              addBtn.textContent = originalText;
            }, 2000);
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = originalText;
          });
      });
    }
    // Paneelmaten komen server-side uit het metaobject (custom.calculator); geen variant-sync nodig.
  })();

  /* ---------- Sticky Add to Cart ---------- */
  (function initStickyATC() {
    var sticky = document.querySelector('.adeqo-sticky-atc');
    var atcBtn = document.querySelector('[data-add-to-cart]');
    if (!sticky || !atcBtn) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('is-visible');
        } else {
          sticky.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(atcBtn);

    // Qty sync: sticky ↔ main qty input
    var stickyQtyVal = sticky.querySelector('.adeqo-sticky-atc__qty-val');
    var stickyQtyBtns = sticky.querySelectorAll('[data-sticky-qty]');
    var mainQtyInput = document.querySelector('[data-qty-select]') || document.querySelector('.adeqo-product-info__quantity-input');

    function getStickyQty() {
      return parseInt(stickyQtyVal && stickyQtyVal.textContent, 10) || 1;
    }
    function setStickyQty(val) {
      var min = mainQtyInput ? parseInt(mainQtyInput.min, 10) || 1 : 1;
      var max = mainQtyInput ? parseInt(mainQtyInput.max, 10) || 999 : 999;
      val = Math.max(min, Math.min(max, val));
      if (stickyQtyVal) stickyQtyVal.textContent = val;
      if (mainQtyInput) {
        mainQtyInput.value = val;
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Init from main qty
    if (mainQtyInput) setStickyQty(parseInt(mainQtyInput.value, 10) || 1);

    stickyQtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = getStickyQty();
        setStickyQty(btn.dataset.stickyQty === 'increase' ? current + 1 : current - 1);
      });
    });

    // Keep sticky in sync when main qty changes externally
    if (mainQtyInput) {
      mainQtyInput.addEventListener('change', function () {
        var val = parseInt(mainQtyInput.value, 10) || 1;
        if (stickyQtyVal && parseInt(stickyQtyVal.textContent, 10) !== val) {
          stickyQtyVal.textContent = val;
        }
      });
    }

    // --- B2B total price (alleen voor is_b2b) ---
    var isB2B = sticky.dataset.b2b === 'true';
    var basePriceCents = parseInt(sticky.dataset.basePrice, 10) || 0;
    var productId = sticky.dataset.productId || null;
    var totalEl = sticky.querySelector('[data-sticky-total]');
    var totalAmountEl = sticky.querySelector('[data-sticky-total-amount]');
    var totalMetaEl = sticky.querySelector('[data-sticky-total-meta]');

    function fmtEur(cents) {
      return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
    }
    function getBssB2BRules() {
      var qb = window.BSS_B2B && window.BSS_B2B.qb;
      return (qb && Array.isArray(qb.qbRules)) ? qb.qbRules : [];
    }
    function getBssCustomerTags() {
      var tags = (window.adeqoCustomer && window.adeqoCustomer.tags) || [];
      if (typeof tags === 'string') tags = tags.split(',');
      return tags.map(function (t) { return String(t).trim().toLowerCase(); }).filter(Boolean);
    }
    function stickyGetTier(rules, pid, tags, qty) {
      var applicable = rules.filter(function (r) {
        if (r.customer_tags) {
          var req = String(r.customer_tags).split(',').map(function (t) { return t.trim().toLowerCase(); });
          if (req.length && !tags.some(function (t) { return req.indexOf(t) !== -1; })) return false;
        }
        var at = parseInt(r.apply_to, 10);
        if (at === 4 && r.product_ids) {
          var ids = String(r.product_ids).split(',').map(function (s) { return s.trim(); });
          if (ids.indexOf(String(pid)) === -1) return false;
        }
        return true;
      });
      if (!applicable.length) return null;
      applicable.sort(function (a, b) { return (a.priority || 0) - (b.priority || 0); });
      var rule = applicable[0];
      if (!rule.qty_table) return null;
      for (var i = 0; i < rule.qty_table.length; i++) {
        var t = rule.qty_table[i];
        var to = (t.qty_to == null) ? Infinity : t.qty_to;
        if (qty >= t.qty_from && qty <= to) return t;
      }
      return null;
    }

    function readBssPriceCents() {
      var selectors = [
        '.adeqo-product-info__price-wrapper[bss-b2b-product-active="true"] .bss-b2b-price-no-vat',
        '.bss-b2b-price-no-vat',
        '[bss-b2b-variant-price]'
      ];
      for (var s = 0; s < selectors.length; s++) {
        var el = document.querySelector(selectors[s]);
        if (!el) continue;
        var txt = el.textContent || el.getAttribute('bss-b2b-variant-price') || '';
        var clean = txt.replace(/[^\d,.\-]/g, '').trim();
        if (!clean) continue;
        if (clean.indexOf(',') !== -1) clean = clean.replace(/\./g, '').replace(',', '.');
        var euros = parseFloat(clean);
        if (!isNaN(euros) && euros > 0) return Math.round(euros * 100);
      }
      return 0;
    }

    function updateB2BTotal() {
      if (!isB2B || !totalEl) return;
      var qty = getStickyQty();
      var bssPrice = readBssPriceCents();
      var unitCents = bssPrice > 0 ? bssPrice : basePriceCents;
      var priceEl = sticky.querySelector('[data-sticky-price]');
      if (priceEl && bssPrice > 0) priceEl.textContent = fmtEur(bssPrice);
      var totalCents = unitCents * qty;
      if (totalAmountEl) totalAmountEl.textContent = fmtEur(totalCents);
      if (totalMetaEl) totalMetaEl.textContent = qty + ' st. · ' + fmtEur(unitCents) + '/st.';
    }

    if (isB2B && totalEl) {
      // Wacht tot BSS DOM-prijzen beschikbaar zijn
      var stickyBssAttempts = 0;
      var stickyBssPoller = setInterval(function () {
        var rules = window.BSS_B2B && window.BSS_B2B.qb && window.BSS_B2B.qb.qbRules;
        if ((rules && rules.length > 0) || stickyBssAttempts >= 10) {
          clearInterval(stickyBssPoller);
          setTimeout(function () {
            totalEl.style.display = 'flex';
            sticky.classList.add('has-b2b-total');
            updateB2BTotal();
          }, 300);
        }
        stickyBssAttempts++;
      }, 400);

      stickyQtyBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { setTimeout(updateB2BTotal, 0); });
      });
      if (mainQtyInput) {
        mainQtyInput.addEventListener('change', function () { setTimeout(updateB2BTotal, 0); });
      }
    }

    // Sync price + variant + stock on variant change
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var priceEl = sticky.querySelector('[data-sticky-price]');
      var variantEl = sticky.querySelector('[data-sticky-variant]');
      var stockEl = sticky.querySelector('[data-sticky-stock]');
      var atcStickyBtn = sticky.querySelector('[data-add-to-cart]');
      if (priceEl) priceEl.textContent = fmtEur(v.price);
      if (variantEl) variantEl.textContent = v.title !== 'Default Title' ? v.title : '';
      if (stockEl) stockEl.textContent = v.available ? window.theme.t('product_in_stock', 'op voorraad') : window.theme.t('product_sold_out', 'uitverkocht');
      if (atcStickyBtn) atcStickyBtn.dataset.variantId = v.id;
      basePriceCents = v.price;
      updateB2BTotal();
    });
  })();

  /* ---------- Cross-sell Block ---------- */
  (function initCrossSell() {
    var items = document.querySelectorAll('[data-crosssell-item]');
    if (!items.length) return;

    // Pak huidige paneel-qty uit ATC quantity input.
    function getPanelQty() {
      var input = document.querySelector('.adeqo-product-info__quantity-input, .adeqo-purchase-row__qty-input, [data-qty-select]');
      if (!input) return 1;
      return Math.max(1, parseInt(input.value, 10) || 1);
    }

    // Aanbevolen aantal:
    //   1. fixed-qty (overrule) → vast aantal
    //   2. ppu → ⌈paneelQty / ppu⌉
    //   3. anders null (geen aanbeveling beschikbaar)
    function calcRecommended(item, panelQty) {
      var fixed = parseInt(item.dataset.crosssellFixed, 10);
      if (fixed > 0) return fixed;
      var ppu = parseInt(item.dataset.crosssellPpu, 10);
      if (!ppu || ppu < 1) return null;
      return Math.max(1, Math.ceil(panelQty / ppu));
    }

    function formatPrice(cents) {
      return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
    }

    items.forEach(function (item) {
      var toggleBtn = item.querySelector('[data-crosssell-toggle]');
      var qtyWrap = item.querySelector('[data-crosssell-qty-wrap]');
      var qtyInput = item.querySelector('[data-crosssell-qty]');
      var qtyMinus = item.querySelector('[data-crosssell-qty-minus]');
      var qtyPlus = item.querySelector('[data-crosssell-qty-plus]');
      var priceEl = item.querySelector('[data-crosssell-price]');
      var metaEl = item.querySelector('[data-crosssell-meta]');
      var unitPrice = parseInt(item.dataset.price, 10) || 0;
      var unitSingular = item.dataset.crosssellUnit || '';
      var unitPlural = item.dataset.crosssellUnitPlural || unitSingular;

      function isActive() { return item.classList.contains('is-active'); }

      function updatePrice() {
        if (!priceEl || !unitPrice) return;
        var qty = isActive() ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var unit = adeqoB2BUnitPrice(item.dataset.productId, unitPrice, qty);
        priceEl.textContent = '+' + formatPrice(unit * qty);
      }

      // Sync stepper-default + meta-text op huidige paneel-qty.
      // Wijzigt qtyInput.value alleen als item nog niet actief is (user heeft 'm dan nog niet aangeraakt).
      function syncToPanelQty() {
        var panelQty = getPanelQty();
        var recommended = calcRecommended(item, panelQty);
        if (recommended == null) return;
        if (!isActive() && qtyInput) qtyInput.value = recommended;
        if (metaEl && unitPlural) {
          var label = recommended === 1 ? unitSingular : unitPlural;
          metaEl.textContent = recommended + ' ' + label + ' aanbevolen';
        }
        updatePrice();
      }

      // Initieel synchroniseren met huidige paneel-qty.
      syncToPanelQty();

      // Toggle aan/uit
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          item.classList.toggle('is-active');
          if (qtyWrap) qtyWrap.style.display = isActive() ? 'flex' : 'none';
          if (isActive()) {
            // Bij aanzetten: vul stepper met huidige aanbeveling
            var rec = calcRecommended(item, getPanelQty());
            if (rec != null && qtyInput) qtyInput.value = rec;
          }
          updatePrice();
        });
      }

      if (qtyMinus) {
        qtyMinus.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) { qtyInput.value = val - 1; updatePrice(); }
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val < 99) { qtyInput.value = val + 1; updatePrice(); }
        });
      }
      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = Math.max(1, Math.min(99, val));
          updatePrice();
        });
      }
    });

    // Live update: paneel-qty wijzigt → re-sync alle items
    document.addEventListener('adeqo:quantity-changed', function () {
      items.forEach(function (item) {
        var qtyInput = item.querySelector('[data-crosssell-qty]');
        var metaEl = item.querySelector('[data-crosssell-meta]');
        var priceEl = item.querySelector('[data-crosssell-price]');
        var unitPrice = parseInt(item.dataset.price, 10) || 0;
        var unitSingular = item.dataset.crosssellUnit || '';
        var unitPlural = item.dataset.crosssellUnitPlural || unitSingular;
        var recommended = calcRecommended(item, getPanelQty());
        if (recommended == null) return;
        var isActive = item.classList.contains('is-active');
        // Geen handmatige aantal-picker meer → aantal volgt altijd het aanbevolen aantal.
        if (qtyInput) qtyInput.value = recommended;
        if (metaEl && unitPlural) {
          var label = recommended === 1 ? unitSingular : unitPlural;
          metaEl.textContent = recommended + ' ' + label + ' aanbevolen';
        }
        if (priceEl && unitPrice) {
          var qty = isActive ? (parseInt(qtyInput.value, 10) || 1) : 1;
          var unit = adeqoB2BUnitPrice(item.dataset.productId, unitPrice, qty);
          priceEl.textContent = '+' + (unit * qty / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
        }
      });
    });

    // Re-render zodra BSS geladen is (B2B-prijzen via quantity-changed listener)
    var csBssRetries = 0;
    var csBssPoller = setInterval(function () {
      var rules = window.BSS_B2B && window.BSS_B2B.qb && window.BSS_B2B.qb.qbRules;
      var bssReady = document.querySelector('[bss-b2b-product-active="true"], .bss-b2b-price-no-vat');
      if ((rules && rules.length > 0) || bssReady || csBssRetries >= 10) {
        clearInterval(csBssPoller);
        setTimeout(function () { document.dispatchEvent(new CustomEvent('adeqo:quantity-changed')); }, 300);
      }
      csBssRetries++;
    }, 400);
  })();

  /* ---------- Vaak Samen Gekocht (bundle) ---------- */
  (function initVaakSamenGekocht() {
    // Een 'bundle' is een [data-crosssell] container met checkbox-items + totaalprijs + Selectie-toevoegen knop.
    // Onderscheidt zich van het stepper-block doordat het [data-crosssell-check] elementen heeft (en geen [data-crosssell-toggle]).
    var bundles = document.querySelectorAll('[data-crosssell]');
    if (!bundles.length) return;

    function getPanelQty() {
      var input = document.querySelector('.adeqo-product-info__quantity-input, .adeqo-purchase-row__qty-input, [data-qty-select]');
      if (!input) return 1;
      return Math.max(1, parseInt(input.value, 10) || 1);
    }

    function calcRecommendedFor(item, panelQty) {
      var fixed = parseInt(item.dataset.crosssellFixed, 10);
      if (fixed > 0) return fixed;
      var ppu = parseInt(item.dataset.crosssellPpu, 10);
      if (!ppu || ppu < 1) return 1;
      return Math.max(1, Math.ceil(panelQty / ppu));
    }

    function formatPrice(cents) {
      return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
    }

    // ---------- BSS B2B price engine (zelfde pattern als staffel-cart-line.js) ----------
    function getCustomerTags() {
      var tags = (window.adeqoCustomer && window.adeqoCustomer.tags) || [];
      if (typeof tags === 'string') tags = tags.split(',');
      return tags.map(function (t) { return String(t).trim().toLowerCase(); }).filter(Boolean);
    }

    function getBssRules() {
      var qb = window.BSS_B2B && window.BSS_B2B.qb;
      return (qb && Array.isArray(qb.qbRules)) ? qb.qbRules : [];
    }

    function ruleApplies(rule, productId, customerTags) {
      if (rule.customer_tags) {
        var required = String(rule.customer_tags).split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
        if (required.length > 0) {
          var hasTag = customerTags.some(function (t) { return required.indexOf(t) !== -1; });
          if (!hasTag) return false;
        }
      }
      var applyTo = parseInt(rule.apply_to, 10);
      if (applyTo === 4 && rule.product_ids) {
        var ids = String(rule.product_ids).split(',').map(function (s) { return s.trim(); });
        if (ids.indexOf(String(productId)) === -1) return false;
      }
      // apply_to=0 → alle producten, apply_to=3 → tags (skip, kunnen we niet checken)
      return true;
    }

    function getActiveRule(productId, customerTags) {
      var rules = getBssRules().filter(function (r) { return ruleApplies(r, productId, customerTags); });
      if (!rules.length) return null;
      rules.sort(function (a, b) { return (a.priority || 0) - (b.priority || 0); });
      return rules[0];
    }

    function getTierForQty(rule, qty) {
      if (!rule || !rule.qty_table) return null;
      for (var i = 0; i < rule.qty_table.length; i++) {
        var t = rule.qty_table[i];
        var to = (t.qty_to == null) ? Infinity : t.qty_to;
        if (qty >= t.qty_from && qty <= to) return t;
      }
      return null;
    }

    // Bereken B2B unit-prijs (cents). Returnt null als geen B2B-rule actief.
    function calcB2BUnitPrice(productId, baseCents, qty, customerTags) {
      if (!productId || !baseCents) return null;
      var rule = getActiveRule(productId, customerTags);
      if (!rule) return null;
      var tier = getTierForQty(rule, qty);
      if (!tier) return null;
      var pct = parseFloat(tier.discount_value) || 0;
      if (pct <= 0) return baseCents;
      // BSS discount_type: 2 of 'percent'/'%' = percentage, 1 of 'fixed' = vast bedrag
      var dtype = tier.discount_type;
      var isPercent = (dtype === 2 || dtype === 'percent' || dtype === '%' || !dtype);
      if (isPercent) {
        return Math.round(baseCents * (100 - pct) / 100);
      }
      // Fixed-amount discount
      return Math.max(0, baseCents - Math.round(pct * 100));
    }

    bundles.forEach(function (bundle) {
      // Skip stepper-blokken (die hebben [data-crosssell-toggle], geen [data-crosssell-check])
      if (!bundle.querySelector('[data-crosssell-check]')) return;

      var items = bundle.querySelectorAll('[data-crosssell-item]');
      var mainItem = bundle.querySelector('[data-crosssell-main]');
      var totalEl = bundle.querySelector('[data-crosssell-total]');
      var addBtn = bundle.querySelector('[data-crosssell-add]');

      // Hoofd-product basisprijs: uit Liquid-rendered data-price (in cents)
      var basePrice = mainItem ? (parseInt(mainItem.dataset.price, 10) || 0) : 0;
      var mainProductId = mainItem ? mainItem.dataset.productId : null;
      var mainPriceEl = mainItem ? mainItem.querySelector('.adeqo-crosssell__price') : null;

      function recompute() {
        var panelQty = getPanelQty();
        var customerTags = getCustomerTags();

        // Hoofd-product: probeer B2B-prijs, anders base price
        // Lees BSS-gerewritte B2B-prijs uit DOM (zelfde aanpak als bss-staffel-adeqo.js).
        // BSS schrijft de excl-BTW prijs naar .bss-b2b-price-no-vat of [bss-b2b-variant-price].
        var mainUnitPrice = basePrice;
        function readBssPrice() {
          var selectors = [
            '.adeqo-product-info__price-wrapper[bss-b2b-product-active="true"] .bss-b2b-price-no-vat',
            '.bss-b2b-price-no-vat',
            '[bss-b2b-variant-price]'
          ];
          for (var s = 0; s < selectors.length; s++) {
            var el = document.querySelector(selectors[s]);
            if (!el) continue;
            var txt = el.textContent || el.getAttribute('bss-b2b-variant-price') || '';
            var clean = txt.replace(/[^\d,.\-]/g, '').trim();
            if (!clean) continue;
            if (clean.indexOf(',') !== -1) clean = clean.replace(/\./g, '').replace(',', '.');
            var euros = parseFloat(clean);
            if (!isNaN(euros) && euros > 0) return Math.round(euros * 100);
          }
          return 0;
        }
        // Alleen voor échte B2B-klanten de excl-BTW BSS-prijs lezen/toepassen.
        // B2C houdt de incl-BTW basisprijs (anders toont de bundle excl. BTW).
        if (adeqoIsB2B()) {
          var bssPrice = readBssPrice();
          if (bssPrice > 0) {
            mainUnitPrice = bssPrice;
          } else if (mainProductId) {
            mainUnitPrice = adeqoB2BUnitPrice(mainProductId, basePrice, panelQty);
          }
        }
        // Toon hoofd-product unit-prijs in de bundle (eerste item)
        if (mainPriceEl) mainPriceEl.textContent = formatPrice(mainUnitPrice);

        var total = mainUnitPrice * panelQty;

        items.forEach(function (item) {
          var baseCents = parseInt(item.dataset.price, 10) || 0;
          var productId = item.dataset.productId;
          var unitSingular = item.dataset.crosssellUnit || '';
          var unitPlural = item.dataset.crosssellUnitPlural || unitSingular;
          var hasRule = item.dataset.crosssellFixed || item.dataset.crosssellPpu;
          var recommended = hasRule ? calcRecommendedFor(item, panelQty) : 1;
          var checkEl = item.querySelector('[data-crosssell-check]');
          var isChecked = checkEl && checkEl.classList.contains('is-checked');
          var metaEl = item.querySelector('[data-crosssell-meta]');
          var priceEl = item.querySelector('[data-crosssell-price]');

          // B2B-preview: strip BTW + staffelkorting (winkelwagen toont exacte prijs)
          var unitCents = adeqoB2BUnitPrice(productId, baseCents, recommended);

          // Update meta-text "N stuks aanbevolen"
          if (metaEl && hasRule) {
            var label = recommended === 1 ? unitSingular : unitPlural;
            metaEl.textContent = recommended + ' ' + label + ' aanbevolen';
          }
          // Update unit price × recommended-qty (B2B-adjusted)
          if (priceEl) priceEl.textContent = formatPrice(unitCents * recommended);
          // Tel mee in totaal als gechecked
          if (isChecked) total += unitCents * recommended;
          // Sla aanbevolen-qty op voor ATC-flow
          item.dataset.recommendedQty = recommended;
        });
        if (totalEl) totalEl.textContent = formatPrice(total);
      }

      // Init: zorg dat hoofd-product correct gerekend wordt (× paneel-qty)
      // Lees hoofdprijs ALS de eerste keer dat we totaal lezen het ALLEEN hoofd-product is.
      // Werkwijze: huidige basePrice is OF data-attribute OF de getoonde totaalprijs.
      // Bij eerste recompute() rekenen we hoofdprijs × panelQty.

      // Checkbox-toggle: ÉÉN listener op de hele item-row (klik op de checkbox
      // bubbelt mee). data-cs-bound voorkomt dubbele binding — vroeger zorgden
      // een aparte checkbox-listener + item-listener voor een dubbele toggle
      // (klik selecteerde dan niets, dus de add-knop voegde niets toe).
      items.forEach(function (item) {
        var checkEl = item.querySelector('[data-crosssell-check]');
        if (!checkEl || item.dataset.csBound) return;
        item.dataset.csBound = '1';
        item.addEventListener('click', function (e) {
          if (e.target.closest('a')) return; // niet bij klik op een link
          checkEl.classList.toggle('is-checked');
          recompute();
        });
      });

      // ATC: voeg hoofd-product (panelQty) + gechecked items (recommended qty each) toe
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var panelQty = getPanelQty();
          var formData = new FormData();
          var mainVariant = document.querySelector('[name="id"]');
          var mainId = mainVariant ? mainVariant.value : null;
          // Pak ook uit hidden field als fallback
          if (!mainId) {
            var fallback = document.getElementById('adeqo-selected-variant-id');
            if (fallback) mainId = fallback.value;
          }
          var itemsToAdd = [];
          if (mainId) itemsToAdd.push({ id: parseInt(mainId, 10), quantity: panelQty });
          items.forEach(function (item) {
            var checkEl = item.querySelector('[data-crosssell-check]');
            if (!checkEl || !checkEl.classList.contains('is-checked')) return;
            var vid = parseInt(item.dataset.variantId, 10);
            var qty = parseInt(item.dataset.recommendedQty, 10) || 1;
            if (vid) itemsToAdd.push({ id: vid, quantity: qty });
          });
          if (!itemsToAdd.length) return;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
          }).then(function (r) { return r.json(); }).then(function () {
            document.dispatchEvent(new CustomEvent('adeqo:cart-added', { detail: { items: itemsToAdd } }));
          });
        });
      }

      // Initiale berekening — wacht tot BSS qbRules beschikbaar zijn
      recompute();
      var bssRetries = 0;
      var bssPoller = setInterval(function () {
        var rules = window.BSS_B2B && window.BSS_B2B.qb && window.BSS_B2B.qb.qbRules;
        if ((rules && rules.length > 0) || bssRetries >= 10) {
          clearInterval(bssPoller);
          // Kleine vertraging zodat BSS ook de DOM-prijzen heeft bijgewerkt
          setTimeout(recompute, 300);
        }
        bssRetries++;
      }, 400);

      // Live update bij paneel-qty change
      document.addEventListener('adeqo:quantity-changed', recompute);
    });
  })();

});

/* ---------- Spinner Animation ---------- */
var style = document.createElement('style');
style.textContent = '@keyframes adeqo-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } .adeqo-spinner { animation: adeqo-spin 1s linear infinite; transform-origin: center; }';
document.head.appendChild(style);
